export const ScheduleBuilderEvents = {
    // Event triggered when schedule options have finished loading
    scheduleOptionsLoaded: "ScheduleBuilder.optionsLoaded",
    // Event triggered when pinned schedules have finished loading
    pinnedSchedulesLoaded: "ScheduleBuilder.pinnedLoaded",
    // Event trigger when a schedule option or pinned schedule's calendar display is being toggled
    scheduleDisplayToggled: "ScheduleBuilder.displayToggled"
};

export const ErrorLevel = {
    course: "course",
    section: "section"
}

export const ErrorCodes = {
    REMOVE_EDIT_SECTION: {
        level: ErrorLevel.section
    },
    REMOVE_ALL_BUT_ONE_SECTION: {
        level: ErrorLevel.section
    },
    REMOVE_ALL_BUT_ONE_SECONDARY_SECTION: {
        level: ErrorLevel.section
    },
    REMOVE_ALL_BUT_ONE_REQUIRED_SECTION: {
        level: ErrorLevel.section
    },
    REMOVE_ALL_BUT_ONE_OF_EACH_SECONDARY_SECTION: {
        level: ErrorLevel.section
    }
};

/**
 * Regular expression to match course codes with section codes like COM 110 A or A&A 444 X2
 */
export const COURSE_CODE_WITH_SECTION_CODE_REGEX = /^(.*)\s([0-9]{3})\s([A-Za-z0-9]{1,2})$/;